// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b7b6d50b","732":"e846aaf3","977":"b3329dfe"}[chunkId] + ".chunk.js";
};